// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    MODALLIGHTBOX_MAIN_CONTAINER: 'modallightbox_main_container',
    MODALLIGHTBOX_CONTENT: 'modallightbox_content',
    MODALLIGHTBOX_BUTTON: 'modallightbox_button',
    MODALLIGHTBOX_ICON: 'modallightbox_icon',
};
